import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react'; 
import BoxCard from './BoxCard';
import VRNBox from './VRNBox';
import '../css/Managehssestyle.css'
//import '../css/customBootstrapExtended.css'
class VehicleGroupTotalSlider extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        return ( 
                  

            <Card className="card border">
                  <Card.Title className="card-header text-center align-items-center" style={{ fontSize: '1rem !important', textAlign:'center', display: 'block !important' }}>
                  <div className="card-title" style={{ fontSize: "0.371rem !important" }}>
                      Total Points
                  </div>
                  </Card.Title>
                  <Card.Body className="text-center"> 
                  <div className="text-center" id="example-caption-3">
                     {this.props.Totalpercentage} Points
                 </div>
                 <div className="progress progress-bar-shell">    
                   <div
                     className="progress-bar"
                     role="progressbar"
                     aria-valuenow={100}
                     aria-valuemin={100}
                     aria-valuemax={100}
                     style={{ width: this.props.Totalpercentage +' Points' }}
                     aria-describedby="example-caption-3"
                   />
                  </div>
                 <h4 style={{ fontSize: "20px" }}>{this.props.Totalpercentage} Points</h4>  
                  </Card.Body>
            </Card>
           
            // <div className="card border">
            //   <div
            //     className="card-header text-center align-items-center"
            //     style={{ display: "block !important" }}
            //   >
            //     <div className="card-title" style={{ fontSize: "1rem !important" }}>
            //       Total
            //       <br />
            //       Percentage %
            //     </div>
            //   </div>
            //   <div className="card-body text-center">
            //     <div className="text-center" id="example-caption-3">
            //     {this.props.Totalpercentage}%
            //     </div>
            //     <div className="progress progress-bar-shell">    
            //       <div
            //         className="progress-bar"
            //         role="progressbar"
            //         aria-valuenow={100}
            //         aria-valuemin={100}
            //         aria-valuemax={100}
            //         style={{ width: "100%" }}
            //         aria-describedby="example-caption-3"
            //       />
            //     </div>
            //     <h4 style={{ fontSize: "33px" }}>{this.props.Totalpercentage}%</h4>
                
            //   </div>
            // </div>
           

            );

        }
        
}
        
        
export default VehicleGroupTotalSlider;